module.exports = __webpack_public_path__ + "img/fb-white.a35bd877.svg";